export default __webpack_public_path__ + "static/media/pic7.e417a1ef.png";